(function () {
  function init(group) {
    if (!group || group.dataset.overviewInit === 'true') return;
    group.dataset.overviewInit = 'true';

    var strip = group.querySelector('[data-overview-strip]');
    var navButtons = group.querySelectorAll('[data-overview-nav]');
    if (!strip || navButtons.length === 0) return;

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var direction = btn.dataset.overviewNav === 'next' ? 1 : -1;
        var firstCard = strip.querySelector('.compare-overview-card');
        var step = firstCard ? firstCard.getBoundingClientRect().width : strip.clientWidth;
        strip.scrollBy({ left: step * direction, behavior: 'smooth' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-overview-group]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-overview-group]').forEach(init);
  });
})();
